<main *ngIf="content && !showSegment">
  <eds-banner-standard
    [edsSpacing]="stickyTabs ? 'auto' : 'xxl'"
    [breadcrumbItems]="breadcrumbItems"
    [theme]="'primary'"
    [preTitle]="content.preTitle"
    [title]="content.title"
    [subTitle]="content.summary?.value"
    [imageSrc]="content.bannerImage"
    [hasRibbon]="true"
  ></eds-banner-standard>

  <div
    *ngIf="stickyTabs"
    [ngClass]="!page?.isPreview() ? 'insights-sticky-tabs' : ''"
  >
    <div edsSpacing="xl">
      <eds-tabs-sticky
        [links]="stickyTabs"
        [activeTab]="activeTabId"
        (onTabChanged)="onTabChange($event)"
        (onHeightChanged)="onHeightChange($event)"
      ></eds-tabs-sticky>
    </div>
  </div>

  <div edsGrid>
    <div class="container container--wide">
      <div edsRow edsSpacing="xl">
        <div edsCol edsSpacing="xl" [columnNumbers]="{ s: 4, m: 6, l: 7 }">
          <!-- Content Blocks -->
          <ng-container
            *ngTemplateOutlet="
              contentBlocks;
              context: { blocks: content.content }
            "
          ></ng-container>
          <!-- Article Listing -->
          <div id="library">
            <ft-insights-library
              [hideSidebars]="true"
              [externalTranslationLabel]="translationLabels"
              [hideLibraryHeader]="true"
              [preFilter]="content.articleFilters"
              [maximumPageSize]="content.articleFilters.maximumCards"
              [externalSIMLogoResource]="simLogoResourceBundle"
              [current]="''"
            ></ft-insights-library>
          </div>
          <!-- ======lowerContent======== -->
          <ng-container
            *ngTemplateOutlet="
              contentBlocks;
              context: { blocks: content.lowerContent }
            "
          ></ng-container>
        </div>

        <div edsCol [columnNumbers]="{ s: 4, m: 6, l: 3 }">
          <eds-panel
            *ngIf="content.logo"
            [hasShadows]="true"
            edsSpacing="xl"
            [hasPadding]="true"
          >
            <eds-article-info
              [logoLink]="content.SIM?.logoSrc"
              [href]="content.SIM?.logoHref"
            ></eds-article-info>
          </eds-panel>

          <!-- Right Rail Content -->
          <ng-container
            *ngTemplateOutlet="
              contentBlocks;
              context: { blocks: content.rightRail }
            "
          ></ng-container>

          <!-- Realted Content Sidebar-->
          <div id="sidebar" edsPadding edsPaddingTop="lg">
            <div #sidebar *ngIf="!isMobile">
              <div class="text-grey1">
                <!-- related content -->
                <ng-container *ngIf="content.relatedContent?.length">
                  <div
                    edsSpacing="xl"
                    *ngFor="let relatedContent of content.relatedContent"
                  >
                    <ng-container
                      *ngIf="relatedContent?.localizableLink?.length"
                    >
                      <eds-sidebar
                        [label]="
                          relatedContent.showHeading
                            ? relatedContentHeaderTypeLabel[
                                relatedContent.heading
                              ]
                            : ('' | uppercase)
                        "
                        [hasShadows]="false"
                        [hasBorders]="false"
                        [hasPadding]="false"
                      >
                        <div
                          *ngFor="
                            let localizeLink of relatedContent.localizableLink;
                            let i = index
                          "
                        >
                          <ng-container *ngIf="localizeLink.isAllowed">
                            <eds-article-sidebar-item
                              [date]="localizeLink.dateString"
                              [title]="
                                localizeLink.link.displayText | decodeHtml
                              "
                              [href]="localizeLink.link.url"
                              [target]="localizeLink.link.target"
                              [isExternalLink]="localizeLink.link.external"
                              [signInRequired]="
                                localizeLink.link.signInLink
                                  | ftIsSignInRequired
                                  | async
                              "
                            ></eds-article-sidebar-item>
                          </ng-container>
                          <ng-container
                            *ngIf="
                              i < relatedContent.localizableLink.length - 1
                            "
                          >
                            <eds-divider
                              *ngIf="localizeLink.isAllowed"
                              edsPadding
                              edsPaddingBottom="sm"
                            ></eds-divider>
                          </ng-container>
                        </div>
                      </eds-sidebar>
                    </ng-container>
                  </div>
                </ng-container>

                <!-- /related content -->
              </div>
            </div>
            <div #stickySidebar>
              <eds-article-side-bar
                [relatedArticleslabel]="
                  content.relatedContent &&
                  content.relatedContent[0]?.showHeading
                    ? relatedContentHeaderTypeLabel[
                        content.relatedContent[0]?.heading
                      ]
                    : ''
                "
                [subscribeFormlabel]="translationLabels?.subscribe"
                [articles]="
                  content.relatedContent?.length
                    ? content.relatedContent[0]
                    : ''
                "
                [showButtons]="showButtons"
                [mobileText]="translationLabels?.moreContent"
                [showArticle]="showArticle"
              >
                <div
                  subscribe
                  class="text-dark-grey article-side-bar__subscribeForm"
                >
                  <p edsSpacing="sm">
                    {{ translationLabels?.subscribeUptoDate }}
                  </p>

                  <div edsSpacing="xs">
                    <eds-text-input
                      [placeholder]="translationLabels?.enterText"
                      [label]="translationLabels?.fullname"
                      type="fullnameType"
                      required="true"
                      aria-label=""
                    ></eds-text-input>
                  </div>
                  <div edsSpacing="xs">
                    <eds-text-input
                      [placeholder]="translationLabels?.enterText"
                      [label]="translationLabels?.email"
                      type="emailType"
                      required="true"
                      aria-label=""
                    ></eds-text-input>
                  </div>
                  <!--<p edsSpacing="sm" class="sidebar__small-font">-->
                  <!--This is a helper text message-->
                  <!--</p>-->
                  <div edsFlexbox justifyContent="flex-end">
                    <button
                      class="ft__btn--no-margin"
                      edsSpacing="xs"
                      href="#"
                      edsButton="primary"
                    >
                      {{ translationLabels?.subscribe }}
                    </button>
                  </div>
                </div>
                <div article class="article-side-bar__articles">
                  <ng-container *ngIf="content.relatedContent?.length">
                    <ng-container
                      *ngIf="content.relatedContent[0]?.localizableLink?.length"
                    >
                      <div
                        *ngFor="
                          let localizeLink of content.relatedContent[0]
                            ?.localizableLink;
                          let i = index
                        "
                      >
                        <ng-container *ngIf="localizeLink.isAllowed">
                          <eds-article-sidebar-item
                            [date]="localizeLink.dateString"
                            [title]="localizeLink.link.displayText"
                            [href]="localizeLink.link.url"
                            [target]="localizeLink.link.target"
                            [isExternalLink]="localizeLink.link.external"
                            [signInRequired]="
                              localizeLink.link.signInLink
                                | ftIsSignInRequired
                                | async
                            "
                          ></eds-article-sidebar-item>
                        </ng-container>
                        <ng-container
                          *ngIf="
                            i <
                            content.relatedContent[0]?.localizableLink.length -
                              1
                          "
                        >
                          <eds-divider
                            *ngIf="localizeLink.isAllowed"
                            edsPadding
                            edsPaddingBottom="sm"
                          ></eds-divider>
                        </ng-container>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </eds-article-side-bar>
            </div>
          </div>
        </div>
      </div>
      <!-- Related Strategies -->
      <div edsRow *ngIf="relatedStrategies" id="strategies">
        <div edsCol>
          <ft-article-related-strategies
            [relatedStrategies]="relatedStrategies"
          ></ft-article-related-strategies>
        </div>
      </div>
      <!-- Related Strategies - END -->
    </div>
  </div>
</main>

<!--Reusable template for content blocks -->
<ng-template let-blocks="blocks" #contentBlocks>
  <ng-container *ngFor="let content of blocks" [ngSwitch]="content.contentType">
    <div [edsSpacing]="content.bottomSpacing">
      <ng-template ngSwitchCase="ftcore:TitleBlock">
        <ft-title-block [content]="content" [isTwoCol]="true"></ft-title-block>
      </ng-template>
      <ng-template ngSwitchCase="ftcore:IntroBlock">
        <ft-text-block [content]="content" [isTwoCol]="true"></ft-text-block>
      </ng-template>
      <ng-template ngSwitchCase="ftcore:ParagraphBlock">
        <ft-text-block [content]="content" [isTwoCol]="true"></ft-text-block>
      </ng-template>
      <ng-template ngSwitchCase="ftcore:LocalizableCardCompund">
        <div
          [edsSubGrid]="
            content?.cardCompound?.length > 1 ? 'layout-1' : ' layout-0'
          "
          *ngIf="content.style === 'Promo Card'"
        >
          <ng-container *ngIf="content.isAllowed">
            <div
              *ngFor="let card of content?.cardCompound; let i = index"
              [edsSpacing]="
                content.isRightRail ? 'none' : content.bottomSpacing
              "
            >
              <eds-promo-card
                [title]="card.title"
                [subTitle]="card.content"
                [promoImageSrc]="card.image"
                [linkBtnHref]="card.href"
                [theme]="i === 0 ? 'primary' : 'secondary'"
                [hasThumbnail]="true"
                [isNewWindow]="card?.isNewWindow"
                [externalLink]="card?.externalLink"
              ></eds-promo-card>
            </div>
          </ng-container>
        </div>
        <div
          edsSpacing="md"
          [edsSubGrid]="'layout-0'"
          *ngIf="content.style === 'Media Card'"
        >
          <ng-container *ngIf="content.isAllowed">
            <eds-media-card
              *ngFor="let card of content?.cardCompound; let i = index"
              [title]="card.title"
              [bodyContent]="card.content"
              [isIcon]="card.isIcon"
              [imgSrc]="card.image"
              [linkText]="card.link?.displayText"
              [url]="card.link?.url"
              [wrap]="true"
              [externalLink]="card.link?.external"
            >
            </eds-media-card>
          </ng-container>
        </div>
        <div
          edsSpacing="md"
          [edsSubGrid]="'layout-0'"
          *ngIf="content.style === 'Feature Card'"
        >
          <ng-container *ngIf="content.isAllowed">
            <eds-card-featured
              [doubleContent]="false"
              [imageFeatured]="true"
              [cards]="content.cardCompound"
              edsSpacing="xl"
            ></eds-card-featured>
          </ng-container>
        </div>
      </ng-template>
      <ng-template ngSwitchCase="ftcore:Avatar">
        <ft-avatar-block
          [isTwoCol]="true"
          [content]="content"
          [page]="page"
          [isRenderedAsArticle]="true"
        ></ft-avatar-block>
      </ng-template>
      <ng-template ngSwitchCase="ftcore:Blockquote">
        <ft-blockquote-block
          [content]="content"
          [isTwoCol]="true"
        ></ft-blockquote-block>
      </ng-template>
      <ng-template ngSwitchCase="ftcore:EmbeddedVideo">
        <eds-video
          *ngIf="content.isAllowed"
          edsSpacing="md"
          [embedScript]="content.videoEmbedCode"
        >
        </eds-video>
      </ng-template>
      <ng-template ngSwitchCase="ftcore:EmbeddedAudio">
        <div
          *ngIf="content.isAllowed"
          [innerHTML]="content.audioEmbedCode | safeHtml"
        ></div>
      </ng-template>
      <ng-template ngSwitchCase="ftcore:ImageCompound">
        <ft-image-block [content]="content"></ft-image-block>
      </ng-template>
      <ng-template ngSwitchCase="ftcore:HighlightBlock">
        <div edsRow [edsSpacing]="content.spacingBottom">
          <div edsCol>
            <eds-highlight-block
              [title]="content.title"
              [bodyContent]="content.content | safeHtml"
            ></eds-highlight-block>
          </div>
        </div>
      </ng-template>
    </div>
  </ng-container>
</ng-template>
